import { useState, useEffect, useContext } from "react";
import { Remediation_func } from "../../../api/devices/remediation/remediation_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip, Card } from "@fluentui/react-components";
import { Info20Regular, GroupList20Regular, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, Info20Filled, Settings20Regular, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { GlobalContext } from "../../../hooks/globalContext";
import { ToastComponent } from "../../../components/toast/toast.component";
import { lightTheme, primaryIcon, overflowDivider, buttonContent, secondaryIcon, messageTheme, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToHumanReadableFormat, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { DevicesPages } from "../../../components/side_menu/InlineSidenav";

export const Remediation = () => {
    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    var tenantName = contextValue.tenantName;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    const [final_data, set_final_data]: any = useState(null);
    const [tableData, setTableData] = useState([]);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [searchVal, setSearchVal] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [isRefresh, setRefresh]: any = useState(false);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [automationName, setAutomationName]: any = useState('');
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [loading, setLoading] = useState(true);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const { permissions } = usePermissionStore();
    const handle = useFullScreenHandle();
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [errorMessage, setErrorMessage] = useState<String>('');
    const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
    const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
    const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
    const [isStatus, setStatus] = useState<any[]>([]);

    useEffect(() => {
        setStatus(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
        setCreatedBy(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    }, [uniqueStatus, uniqueCreatedBy])

    //filter function starts here
    const handleFilterArray = (): any => {
        const value1 = dropDownValue1;
        const value2 = dropDownValue2;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setLoading(true);
        setDropDownValue1('');
        setDropDownValue2('');
        if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
            setErrorMessage(`${dropDownValue1} is already filtered.`);
            return;
        } else {
            setErrorMessage(''); // Clear the message if no issue
        }
    }

    const handleCloseFilter = (index: any): any => {
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        setLoading(true);
    }

    useEffect(() => {
        if (filterArray.length > 0) {
            setResetDisabled(false)
        } else {
            setResetDisabled(true)
        }
    }, [filterArray])

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9_ \-]*$/;
        const regexN = /^[0-9]*$/;
        if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
            setErrorMessage(`${dropDownValue1} is already filtered.`);
            console.log("*****************************")
            return;
        } else {
            setErrorMessage(''); // Clear the message if no issue
        }
        if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Type")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        // if (name === 'filter' && dropDownValue1 === ("Created By")) {
        //     if (regexS.test(enteredValue)) {
        //         setDropDownValue2(enteredValue);
        //     }
        // }
    }
    //filter function ends here

    const handleNavigation = (val: any) => {
        localStorage.setItem('automationDetails', JSON.stringify({ automationName: val.automationName, automationType: val.types.toLocaleLowerCase() }));
        localStorage.setItem('dartNo', val.dartid);
        contextValue.setDartNo(val.dartid);
        contextValue.setAutomationDetails({ ...contextValue.automationDetails, automationName: val.automationName, automationType: val.types.toLocaleLowerCase() });

        navigate("/manage/devices/remediation/assignment");
    }

    useEffect(() => {
        setSearchVal('');
        setFilterArray([]);
        setIsFilter(false);
        setDropDownValue2('');
        setResetDisabled(true);
    }, [contextValue]);

    //data table column name code starts here
    // var columns = [
    //     { key: "automation_name", label: <Body1Strong>&nbsp; Name </Body1Strong> },
    //     { key: "type", label: <Body1Strong> Type </Body1Strong> },
    //     { key: "created_by", label: <Body1Strong> Created By </Body1Strong> },
    //     { key: "created_on", label: <Body1Strong> Created On (UTC)</Body1Strong> },
    //     { key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone})</Body1Strong> },
    //     { key: "last_modified", label: <Body1Strong> last Modified &nbsp;&nbsp;(UTC)</Body1Strong> },
    //     { key: "last_modified_timezoned", label: <Body1Strong> last Modified ({formattedTimeZone})</Body1Strong> },
    //     { key: "status", label: <Body1Strong> Status </Body1Strong> },
    // ];
    //data table column name code ends here

    //filter column names starts here
    // var columns1 = [
    //     { key: "name", label: <Caption1> Name </Caption1> },
    //     { key: "type", label: <Caption1> Type </Caption1> },
    //     { key: "created_by", label: <Caption1> Created By </Caption1> },
    //     { key: "created_on", label: <Caption1> Created On </Caption1> },
    //     // { key: "created_on_timezoned", label: <Caption1> Created On ({formattedTimeZone})</Caption1> },
    //     { key: "last_modified", label: <Caption1> last Modified </Caption1> },
    //     // { key: "last_modified_timezoned", label: <Caption1> last Modified ({formattedTimeZone})</Caption1> },
    //     { key: "status", label: <Caption1> Status </Caption1> },
    //     // { key: "category", label: <Caption1> Category </Caption1> },
    //     // { key: "sub_category", label: <Caption1> Sub Category </Caption1> },
    // ];
    //filter column names ends here
    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    useEffect(() => {
        contextValue?.tableColumnsData?.Devices?.Remediation_list.forEach((val) => {
            if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
                if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
                    tableColumns[val.priority] = ({
                        key: val.key,
                        label:
                            <>
                                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                    <StackItem>
                                        <Body1Strong>{`${val.name}`}</Body1Strong>
                                    </StackItem>
                                    <StackItem align="center">
                                        <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                            <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                        </Tooltip>
                                    </StackItem>
                                </Stack>
                            </>
                    });
                } else {
                    tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
                }
            }

            if (val.display.filter.toLocaleLowerCase() === "yes") {
                filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
            }
        });

        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);

        contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Devices?.Remediation_list.filter((val) => val.priority >= 0));

        contextValue.setManageViewPageDetails({ module: "Devices", page: "Remediation_list" });
    }, [contextValue.tableColumnsData]);

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setRefresh(true); setCurrentPageNo(1); setLoading(true); }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem>
                    {
                        permissions.includes("all") || permissions.includes("remediation_Fullaccess") || permissions.includes("remediation_ReadandExport") ? (
                            <>
                                <CSVLink id="csv-export-link" data={exportData}
                                    filename={`${tenantName}_${localStorage.getItem('assignmentType') === 'conditionalaccess' ? 'ConditionalAccessList' :
                                        localStorage.getItem('assignmentType') === 'policy' ? 'CompliancePolicyList' :
                                            localStorage.getItem('assignmentType') === 'survey' ? 'UserSurveyList' :
                                                'AssignmentList'
                                        }.csv`}
                                >
                                </CSVLink>
                                <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary":"Remediation list exported"}`);*/ }}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        ) :
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button shape="circular" appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                    }
                </StackItem>

                <StackItem>
                    <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
        ,
    };
    // overflow set contents code ends here

    var tempTableData: any = [];

    //Export details hook starts here
    useEffect(() => {
        var tempExportData: any = [];
        var status = '';

        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            if (val.status == 'not attached') {
                status = 'Not attached';
            } else {
                var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

                if (curStatus.length == 0) {
                    status = 'Not attached';
                } else {
                    curStatus = curStatus[0]?.split(":")[1];

                    if (curStatus == 'all') {
                        status = 'Enabled for All Devices';
                    } else {
                        status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
                    }
                }
            }

            tempExportData.push({
                'Automation Name': val.automationName,
                'Type': val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1),
                'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
                'Attached On': val.attachedOn != null ? convertToExcelFormat(val.attachedOn) : "-",
                'Attach Modified': val.attachModified ? convertToExcelFormat(val.attachModified) : "-",
                'Status': status
            });
        });
        setExportBtnClicked(false);
        setExportData(tempExportData);
    }, [exportDetails]);
    //Export details hook ends here


    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    useEffect(() => {
        if (final_data !== undefined && final_data !== null) {
            const newUniqueCreatedBy: string[] = [];
            const newUniqueStatus: string[] = [];

            final_data?.forEach((val: any) => {
                if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
                    newUniqueCreatedBy.push(val.createdBy);
                }
                if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
                    newUniqueStatus.push(val.status);
                }
            });
            setUniqueCreatedBy(newUniqueCreatedBy);
            setUniqueStatus(newUniqueStatus);
            console.log("Unique Created By:", newUniqueCreatedBy);
        } else {
            setUniqueCreatedBy([]);
            setUniqueStatus([]);
        }
    }, [final_data]);

    // data table values append code starts here
    useEffect(() => {

        var status = '';
        final_data !== undefined && final_data !== null ?
            final_data.map((val: any, i: any) => {
                if (val.status == 'not attached') {
                    status = 'Not attached';
                } else {
                    var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

                    if (curStatus.length == 0) {
                        status = 'Not attached';
                    } else {
                        curStatus = curStatus[0]?.split(":")[1];

                        if (curStatus == 'all') {
                            status = 'Enabled for All Devices';
                        } else {
                            status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
                        }
                    }
                }

                {
                    permissions.includes("all") || permissions.includes("remediation_Fullaccess") ?
                        tempTableData.push({
                            id: val.id,
                            checkbox: 'hide',
                            automation_name: { label: <Button style={buttonContent} id="ButtonHover" appearance="transparent" size="small" onClick={() => { handleNavigation(val) }}> {val.automationName} </Button >, id: `${i}` },
                            type: { label: <Caption1> {val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1)} </Caption1>, status: "" },
                            created_by: { label: <Caption1> {val.createdBy} </Caption1> },
                            attached_on: { label: <Caption1> {convertUTCToReadableFormat(val.attachedOn)} </Caption1> },
                            attached_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.attachedOn, userTimeZone)} </Caption1> },
                            attach_modified: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
                            attach_modified_timezoned: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
                            status: { label: <Caption1> {status} </Caption1>, status: "" },
                            category: { label: <Caption1> {val.category} </Caption1>, },
                            subCategory: { label: <Caption1> {val.subCategory} </Caption1>, },
                        })
                        :
                        tempTableData.push({
                            id: val.id,
                            checkbox: 'hide',
                            automation_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button>
                                    </Tooltip>, id: `${i}`
                            },
                            type: { label: <Caption1> {val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1)} </Caption1>, status: "" },
                            created_by: { label: <Caption1> {val.createdBy} </Caption1> },
                            attached_on: { label: <Caption1> {convertUTCToReadableFormat(val.attachedOn)} </Caption1> },
                            attached_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.attachedOn, userTimeZone)} </Caption1> },
                            attach_modified: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
                            attach_modified_timezoned: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
                            status: { label: <Caption1> {status} </Caption1>, status: "" },
                            category: { label: <Caption1> {val.category} </Caption1>, },
                            subCategory: { label: <Caption1> {val.subCategory} </Caption1>, },
                        });
                }
            })
            : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);

            if (isRefresh) {
                setRefreshToast(true);
                setTimeout(() => {
                    setRefresh(false);
                    setRefreshToast(false);
                }, 3000);
            }
        }, 500);
    }, [final_data, permissions]);
    // data table values append code ends here

    useEffect(() => {
        contextValue.assignmentType.length > 0 && setLoading(true);
    }, [contextValue.assignmentType]);


    useEffect(() => {
        const pageNo = (currentPageNo - 1) * 50;

        const props: any = {
            data: final_data,
            func: set_final_data,
            searchVal: searchVal,
            pageNo: pageNo,
            setTotalPages: setTotalPages,
            setTotalRecords: setTotalRecords,
            isFilter: isfilter,
            setIsFilter: setIsFilter,
            isRefresh: isRefresh,
            setRefresh: setRefresh,
            setRefreshToast: setRefreshToast,
            filterArray: filterArray,
            exportBtnClicked: exportBtnClicked,
            setExportBtnClicked: setExportBtnClicked,
            setExportDetails: setExportDetails,
            tenant: tenantName,
            assignmentType: contextValue.assignmentType,
            loading: loading,
        }

        Remediation_func(props);
    }, [isRefresh, searchVal, currentPageNo, isfilter, filterArray, exportBtnClicked, contextValue.assignmentType]);

    const navs = () => {
        const menus = {
            "/remediation": "Assignment",
            "/compliancepolicies": "Compliance Policies",
            "/conditionalaccess": "Conditional Access",
            "/usersurvey": "User Survey",
        };
        return DevicesPages(menus[Object.keys(menus).find(key => window.location.pathname.endsWith(key))] || []);
    };

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder} >
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    {/* <Breadcrumbs pageName="Devices" subPageName="" />  */}
                                    <Breadcrumbs
                                        items={[
                                            { name: "Manage", link: "/home" },
                                            { name: "Devices", link: "/manage/devices/overview" },
                                            {
                                                name: localStorage.getItem('assignmentType') === 'conditionalaccess'
                                                    ? 'Conditional Access'
                                                    : localStorage.getItem('assignmentType') === 'policy'
                                                        ? 'Compliance Policies'
                                                        : localStorage.getItem('assignmentType') === 'survey'
                                                            ? 'User Survey'
                                                            : 'Assignment',
                                                link: "#"
                                            }
                                        ]}
                                    />
                                </StackItem>
                            </Stack>
                        </StackItem>
                        {/* <StackItem grow shrink>
                            <Stack horizontalAlign="end">
                                <StackItem grow shrink>
                                    <FullScreenButton handle={handle} />
                                </StackItem>
                            </Stack>
                        </StackItem> */}
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>
                            {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                                <StackItem> <Text></Text> </StackItem>
                                <StackItem>
                                    <FluentProvider theme={dashboardTheme}>
                                        <Title3> Devices | {localStorage.getItem('assignmentType') === 'conditionalaccess' ? 'Conditional Access' : localStorage.getItem('assignmentType') === 'policy' ? 'Compliance Policies' : localStorage.getItem('assignmentType') === 'survey' ? 'User Survey' : 'Assignment'} </Title3>
                                    </FluentProvider>
                                </StackItem>
                            </Stack> */}
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    {/* <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} /> */}
                                    {/* <FluentProvider theme={sidenavTheme} style={parentHome}> */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={navs()} />
                                    {/* </FluentProvider> */}
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                {tableData.length > 0 ? <Divider /> : <Divider />}
                                            </StackItem>
                                            <StackItem style={wraperStyle}>
                                                <StackItem>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                            <StackItem>
                                                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn=
                                                                    {
                                                                        <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                                <Body1> Filter </Body1>
                                                                            </Stack>
                                                                        </MenuButton>
                                                                    } itemVal={
                                                                        <>
                                                                            <Body1Strong> Add a Filter </Body1Strong>
                                                                            <Divider />
                                                                            <MenuList>
                                                                                <Stack tokens={{ childrenGap: 5 }}>
                                                                                    <StackItem> <Text></Text> </StackItem>
                                                                                    <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                                    <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                                    <StackItem> <Divider /> </StackItem>
                                                                                    <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                                    {(dropDownValue1 === 'Created On' || dropDownValue1 === 'last Modified') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                                                                    {(dropDownValue1 === "Name" || dropDownValue1 === "Type") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                                    {(dropDownValue1 === "Status") && <DropdownComponent optionData={isStatus} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                                                                    {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                                    <StackItem> <Divider /> </StackItem>
                                                                                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                        <StackItem>
                                                                                            <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                                <Caption1> Apply </Caption1>
                                                                                            </Button>
                                                                                        </StackItem>

                                                                                        <StackItem>
                                                                                            <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                                <Caption1> Cancel </Caption1>
                                                                                            </Button>
                                                                                        </StackItem>
                                                                                    </Stack>
                                                                                </Stack>
                                                                            </MenuList>
                                                                        </>
                                                                    }
                                                                />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true) }}>
                                                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>

                                                    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                                                        <StackItem>
                                                            {filterArray.length > 0 && (
                                                                <Stack horizontal wrap>
                                                                    {filterArray.map((item, index) => (
                                                                        <Button shape="circular" size="small">
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                <StackItem>
                                                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                                                        <StackItem><Text></Text></StackItem>
                                                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                    </Stack>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Button>
                                                                    ))}
                                                                </Stack>
                                                            )}
                                                        </StackItem>

                                                        <StackItem disableShrink>
                                                            {(tableData.length > 0 && !loading) && (
                                                                totalRecords > 0 &&
                                                                <Caption1>
                                                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                </Caption1>
                                                            )}
                                                        </StackItem>
                                                    </Stack>
                                                </StackItem>

                                                {localStorage.getItem('assignmentType') === 'conditionalaccess' ?
                                                    (<InfoBar showSpaces={true} title={"Attach or detach protection policy to all devices or specific device classifications created in the automate section."} />)
                                                    : localStorage.getItem('assignmentType') === 'policy' ?
                                                        (<InfoBar showSpaces={true} title={"Attach or detach compliance policies to all devices or to specific device classifications created in the Automation section."} />)
                                                        : localStorage.getItem('assignmentType') === 'survey' ?
                                                            (<InfoBar showSpaces={true} title={"Attach or detach protection policy to all devices or specific device classifications created in the automate section."} />)
                                                            : (<InfoBar showSpaces={true} title={"Attach or detach Selfhelp, Proactive, Scheduler, and Autoheal to all devices or specific device classifications created in the automate section."} />)}
                                            </StackItem>
                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>

                        <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData="Census" />
                    </StackItem>

                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    );
};